import { styled } from "styled-components";

import { Button } from "../Button";
import { Input } from "../Input";

type ContainerProps = {
  /** Use shadow to make footer be more prominent (when chat has ended) */
  $withShadow: boolean;
  /** Show "Powered by TOMIS" */
  $withWatermark: boolean;
};

export const Container = styled.div<ContainerProps>(
  ({ theme, $withShadow, $withWatermark }) => {
    return {
      padding: `${theme.space[3]} ${theme.space[4]} ${theme.space[4]} ${theme.space[4]}`,
      borderRadius: theme.radii[1],

      [`& ${Input.Container}`]: {
        flex: 1,
      },

      [`& ${Button.Container}`]: {
        width: "100%",
      },
      ...($withShadow ? { boxShadow: `0 12px 48px ${theme.shadows[16]}` } : {}),
      ...($withWatermark ? { paddingBottom: "0" } : {}),
    };
  },
);

export const Watermark = styled.div(({ theme }) => {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: `10px 0 ${theme.space[3]} 0`,
    fontSize: 12,
    lineHeight: "17px",
    color: theme.colors.grayDark,

    "& a": {
      marginLeft: "0.5ch",
      textDecoration: "none",
      color: theme.colors.blue,

      "&:focus": {
        outline: 0,
      },
    },
  };
});
